import { createSelector } from 'reselect';
const emptyEpg = Object.freeze({});

/**
    START CLEAN-UP POST EPG MIGRATION
    Strictly for testing while we transition to broadcast epg
    This will only be processed on the client
*/
let useContentEpgOverride;

if (typeof URLSearchParams !== 'undefined' && typeof location !== 'undefined') {
    const params = new URLSearchParams(location.search);
    const useContentEpgParam = params.get('useContentEpg');
    if (useContentEpgParam !== null) {
        useContentEpgOverride = useContentEpgParam === 'true';
    }
}

export const getUseContentEpg = (state) => {
    const { views: { view }, config = {} } = state;
    return useContentEpgOverride ?? config[view]?.useContentEpg ?? config?.useContentEpg ?? false;
};

/* END CLEAN-UP POST EPG MIGRATION */

export const getEpgConfig = (state) => {
    const { views: { view }, config = {} } = state;
    return config[view]?.epg ?? config?.epg ?? emptyEpg;
};

const getDictionary = (state) => state?.views?.dictionary || state?.config?.dictionary;

export const getBroadcastsConfigState = createSelector(
    [getEpgConfig, getUseContentEpg, getDictionary],
    (epg, useContentEpg, dictionary) => {
        return { epg, useContentEpg, dictionary };
    }
);
